const swiperHeroBigSlider = new Swiper('.hero-big-slider__swiper', {
	direction: 'horizontal',
	loop: true,
	autoplay: {
		delay: 0,
		disableOnInteraction: false
	},
	slidesPerView: 'auto',
	spaceBetween: 32,
	speed: 1500,
	effect: 'slide',
	grabCursor: true
});

const swiperHeroSmallSlider = new Swiper('.small-slider__swiper', {
	direction: 'horizontal',
	slidesPerView: 'auto',
	spaceBetween: 20,
	grabCursor: true,
	loop: true,
	pagination: {
		el: '.swiper-pagination',
		clickable: true
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	}
});
